import styled from 'styled-components';
import { getSizeBy } from '../../../src/styled/utils';
export const StyledTabsList = styled.div `
  display: flex;
  flex-direction: row;
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  column-gap: ${getSizeBy(2.25)};
`;
